import { UserAppealResponse, AppealReplyResponse, AppealTopic } from "../../../types/api/appeals";
import { getAppealFromString, getColorVariantForAppealTopic } from "../../../types/api/appeals";
import { UserHeaderCard } from "../../basic/UserHeaderCard";
import { Stack, Text, Label } from "@primer/react";

interface AppealCardProps {
    data: UserAppealResponse | AppealReplyResponse;
    onClick?: () => void;
}

export const AppealCard = ({ data, onClick }: AppealCardProps) => {
    const isUserAppeal = 'user' in data && 'status' in data;
    const appeal = data as UserAppealResponse;
    const reply = data as AppealReplyResponse;

    const statusView = () => {
        if (!isUserAppeal) return null;

        const topicModel = appeal.topic;
        let appealTopic = getAppealFromString(topicModel.title)
        let variant = getColorVariantForAppealTopic(appealTopic ?? AppealTopic.Other)
        return <Label variant={variant}>{topicModel.title}</Label>
    };

    return (
        <div className="bg-header border border-border rounded-lg w-full mb-2">
            <div className="bg-white w-full rounded-t-lg border-b">
                <div className="p-4">
                    {isUserAppeal ? (
                        <UserHeaderCard
                            user={appeal.user ?? null}
                            isLarge={false}
                            onClick={onClick}
                            isSupport={false}
                        />
                    ) : (
                        <UserHeaderCard
                            user={{
                                id: 'support',
                                username: null,
                                number: 0,
                                avatar: null
                            }}
                            isLarge={false}
                            isSupport={true}
                            onClick={undefined}
                        />
                    )}
                </div>
            </div>
            <div className="bg-header w-full rounded-b-lg border-b">
                <div className="mt-4 ml-[14px] mr-[14px] mb-4">
                    {isUserAppeal && statusView()}
                    <Stack direction="horizontal" justify="space-between" gap="condensed">
                        <Stack direction="horizontal" align="center" gap="condensed">
                            <Text className='text-[14px] text-aloix-grey ml-1 mt-3 break-words'>
                                {isUserAppeal ? appeal.text : reply.text}
                            </Text>
                        </Stack>
                    </Stack>
                </div>
            </div>
        </div>
    );
};